import type { ReactNode } from 'react'
import { useMaintenanceStore } from '@/stores/useMaintenanceStore'
import { useMaintenancePolling } from '../useMaintenancePolling'
import { MaintenanceScreen } from './MaintenanceScreen'
import { isPublicPath } from '@/routes/publicPaths'

/**
 * Keeps the lockout screen above authentication.
 *
 * A locked-out user cannot sign in, so the explanation has to reach them before
 * authentication is attempted — which is why this sits outside AuthInit and
 * polls on its own unauthenticated client.
 *
 * The advance warning for a *scheduled* window is not here: it is only useful
 * to someone already working, so it renders in the one notice strip inside the
 * dashboard layout alongside the announcements. See features/notices.
 */
export function MaintenanceGate({ children }: { children: ReactNode }): React.ReactElement {
  useMaintenancePolling()
  const lockedOut = useMaintenanceStore((s) => s.lockedOut)

  // The marketing site stays up during maintenance; only the app is locked.
  if (lockedOut && !isPublicPath()) return <MaintenanceScreen />

  return <>{children}</>
}
